import PropTypes from "prop-types";
import classnames from "classnames";

import Card from "../Card";

import "./toolbar.scss";

const Toolbar = ({ className, title, headerCTA, collapsible, children }) => {
  return (
    <div className={classnames("toolbar", className)}>
      <Card
        id="toolbar"
        title={title || " "}
        collapsible={collapsible}
        headerCTA={headerCTA}
        collapseText={false}
      >
        {children && <div className="toolbar__container">{children}</div>}
      </Card>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  headerCTA: PropTypes.node,
  collapsible: PropTypes.bool,
  children: PropTypes.node,
};

export default Toolbar;
